import styled from "styled-components";
import * as common from "../../common";

export const row = styled(common.flexRow)`
  width: 30%;
`;
export const column = styled(common.flexColumn)`
  min-height: 90vh;
`;
